import { render } from "./RegSuccess.vue?vue&type=template&id=0f0ac2c1"
import script from "./RegSuccess.vue?vue&type=script&lang=js"
export * from "./RegSuccess.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__